export default __webpack_public_path__ + "static/blob9-649eb6516c87ffe38841b0f0b902ef78.svg";